import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailPurposesComponent from './loansDetailPurposes.component';

let loansDetailPurposesModule = angular.module('loansDetailPurposes', [
  uiRouter
])

.component('loansDetailPurposes', loansDetailPurposesComponent)

.name;

export default loansDetailPurposesModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailPurposes/loansDetailPurposes.js